import type { ReactNode } from 'react';

/**
 * Un escalar que importa — la primitiva `stat` de tbit-canvas.
 *
 * `emphasis` pinta el número en mint, y por eso NO es un adorno que se pueda
 * poner en todas: el mint es el dato, así que sólo lo lleva la cifra que salió
 * de la cuenta y que la pantalla quiere que se lea primero. Si todas las
 * baldosas son mint, ninguna lo es.
 */
interface Props {
  title: string;
  value: ReactNode;
  desc?: ReactNode;
  tone?: 'default' | 'data' | 'friction' | 'brand';
  className?: string;
}

const TONE_CLASS: Record<NonNullable<Props['tone']>, string> = {
  default: '',
  data: 'text-data',
  friction: 'text-friction',
  brand: 'text-brand',
};

export default function Stat({ title, value, desc, tone = 'default', className }: Props) {
  return (
    <div className={className ? `stat ${className}` : 'stat'}>
      <div className="stat-title">{title}</div>
      <div className={`stat-value ${TONE_CLASS[tone]}`}>{value}</div>
      {desc && <div className="stat-desc">{desc}</div>}
    </div>
  );
}
